
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface AgeFieldProps {
  age?: number;
  setAge: (age: number | undefined) => void;
  error?: string;
}

const AgeField = ({ age, setAge, error }: AgeFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="age">
        Age <span className="text-red-500">*</span>
      </Label>
      <Input
        id="age"
        type="number"
        placeholder="Your age"
        value={age === undefined ? '' : age}
        onChange={(e) => {
          const value = e.target.value;
          setAge(value === '' ? undefined : parseInt(value, 10));
        }}
        className={error ? 'border-red-500' : ''}
        min="10"
        max="100"
        required
      />
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default AgeField;
